import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { createContext, type PropsWithChildren } from "react";
import { apiService } from "@/lib/api-service";
import type { SessionData } from "@/types/session";

export const sessionContext = createContext<SessionData>({} as SessionData);

interface Props extends PropsWithChildren {
	session: SessionData;
}

/**
 * Provides session data to its child components.
 * This ensures that session data is fetched and available throughout the component tree.
 */
export function SessionProvider({ children, session }: Props) {
	const { data } = useQuery({
		queryKey: ["session"],
		queryFn: async () => apiService.getSession(),
		initialData: session,
		placeholderData: keepPreviousData,
	});

	return (
		<sessionContext.Provider value={data ?? session}>
			{children}
		</sessionContext.Provider>
	);
}
